
export const consultorios_item = [
    {
        "Ubicacion": "Palacio de Gobierno",

        "telefono": "Ext. 6890 y 6843 ",
        "especialidades": [
            {
                "nombre": "Consulta General",
                "icono": "consulta.png"
            },
            {
                "nombre": "Enfermería",
                "icono": "enfermeria.png"
            },
            {
                "nombre": "Nutrición",
                "icono": "nutricion.png"
            },
            {
                "nombre": "Psicología",
                "icono": "psicologia.png"
            },
            {
                "nombre": "Dentista",
                "icono": "dentista.png"
            }
            
        ]
       
    },
    {
        "Ubicacion": "Centro Minero",
        "telefono": "Ext. 8599 ",
        "especialidades": [
            {
                "nombre": "Consulta General",
                "icono": "consulta.png"
            },
            {
                "nombre": "Enfermería",
                "icono": "enfermeria.png"
            },
            
        ]
       
    },
    {
        "Ubicacion": "Centro Cívico",
        "telefono": "Ext. 9918 ",
        "especialidades": [
            {
                "nombre": "Consulta General",
                "icono": "consulta.png"
            },
            {
                "nombre": "Enfermería",
                "icono": "enfermeria.png"
            },
            {
                "nombre": "Psicología",
                "icono": "psicologia.png"
            },
            
        ]
       
    },
    {
        "Ubicacion": "CAIC",
        "telefono": "7717131253 ",
        "especialidades": [
            {
                "nombre": "Atención Interna",
                "icono": "caic.png"
            },
          
            
        ]
       
    },

]


